<template>
  <div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
        <!-- <el-row style="margin-bottom:10px;">
          <el-col>
            <el-form-item label="引题:" prop="Introduction">
                <el-input v-model="ruleForm.Introduction" placeholder="选填，不超过80个字"></el-input>
            </el-form-item>
          </el-col>
          
        </el-row> -->
        <el-row style="margin-bottom:10px;">
          <el-col>
            <el-form-item label="标题:" prop="title">
              <el-input v-model="ruleForm.title" placeholder="必填，不能超过80个字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row>
          <el-col>
            <el-form-item label="副标题:" prop="viceTitle">
              <el-input v-model="ruleForm.viceTitle" placeholder="选填，不能超过80个字"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row style="margin-bottom:10px;">
          <el-col :span="12">
            <el-form-item label="作者:" prop="author">
                <el-input v-model="ruleForm.author" placeholder="选填，不超过10个字"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源:" prop="source">
              <el-input v-model="ruleForm.source" placeholder="选填，不超过10个字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        

        <el-row style="margin-bottom:10px;">
          <el-form-item label="稿件正文:" >
            <!-- <div slot="label" class="labelclass">
              稿件正文:
              <p>
                <span @click="quickFormat" style="color:#185ED3;cursor: pointer;">一键排版<span style="opacity: 0;">:</span></span>
              </p>
            </div> -->
            <div id="websiteEditorElem" style="height:300px;background: #ffffff;"></div>
          </el-form-item>
        </el-row>

        <el-row style="margin-top:50px;">
          <el-form-item label="图片尺寸:">
            <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'" v-model="ruleForm.imgsize" @change="imgsizeChange">
              <el-radio label="small">小图</el-radio>
              <el-radio label="middle">大图</el-radio>
              <el-radio label="big">高清图</el-radio>
            </el-radio-group>
          </el-form-item>
          
        </el-row>

    </el-form>

    <!-- <div class="picbj">
      <div class="picanddesc" v-for="(e,i) in choosePic" :key="i">
        <div class="pic" :style="{backgroundImage:'url(' + e.src +')'}"></div>
        <el-input style="margin-left:50px;" type="textarea" :autosize="{ minRows: 6, maxRows: 6}" v-model="desc" placeholder="图片描述，200个字以内"></el-input>
      </div>
    </div> -->

    <div class="bottombtn">
        <div class="btn">
          <el-button @click="closeForm">取消</el-button>
          <el-button @click="submitForm('ruleForm')" type="primary">确认</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import { addQuillTitle } from "@/plugins/quill-title.js";
import E from "wangeditor";
import SparkMD5 from "spark-md5";
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import {
  listAtlasPictures,getPictures
} from "@/api/picture";
  import { getDate } from "@/plugins/getdate";
  import { picPrefix } from "@/constants/piccommon";
  import {
    listAuthRole
  } from "@/api/authRole";
  export default {
    data() {
      return {
        picPrefix,
        isAct:'',
        imgList:[],

        choosePic:[],
        desc:'',
        roleName:[],
        ruleForm: {
          title: '',
          author: '',
          source:'',
          content: '',
          imgsize:'middle'
          // createAt:''
        },
        rules: {
          title: [
            { required: true, message: '请输入标题', trigger: 'change' },
            { max: 80, message: '长度不超过80个字符', trigger: 'blur' }
          ],
          author: [
            { required: true, message: '请输入作者姓名', trigger: 'change' },
            { max: 10, message: '长度不得超过10个字符', trigger: 'blur' }
          ],
          source: [
            { required: true, message: '请输入来源', trigger: 'change' },
            { max: 10, message: '长度不得超过10个字符', trigger: 'blur' }
          ]
        },

        //富文本编辑器内容
        phoneEditor: "",
        content: ``,
        editorOption: {
          modules: {
            toolbar: [
              ["bold", "italic", "underline", "strike"], //不需要设置值，直接写名字
              [{ header: 1 }, { header: 2 }], //需要设置值
              [{ script: "sub" }, { script: "super" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ color: [] }, { background: [] }] // 字体颜色，字体背景颜色
            ]
          }
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.ruleForm.content = this.phoneEditor.txt.html() 
            this.$emit('submitForm',this.ruleForm,this.choosePic)
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      closeForm() {
        if(this.isAct === true){
          this.$router.go(-1)
        }else{
          this.$emit('closeForm')
        }
        
      },


      imgsizeChange(){
        let images
        this.ruleForm.content = ''
        for (let i = 0; i < this.imgList.length; i++) {
          if(this.ruleForm.imgsize === "small"){
            images = "<img class='img' src='"+ this.imgList[i].srcsmall +"'><br/>"
          }else if(this.ruleForm.imgsize === "big"){
            images = "<img class='img' src='"+ this.imgList[i].srcbig +"'><br/>"
          }else{
            images = "<img class='img' src='"+ this.imgList[i].src +"'><br/>"
          }
          this.ruleForm.content += images
        }
        this.phoneEditor.txt.html(this.ruleForm.content)
        
      },


      quickFormat(){
        var content_arr = this.ruleForm.text.replace("\r", "").split("\n");
        var tempcontent = '';
        for (var i = 0; i < content_arr.length; i++) {
            if (content_arr[i].trim() !== "") {
                var temp = "  " + content_arr[i].trim() + "\n\n";
                tempcontent = tempcontent + temp;
            }
        }
        this.ruleForm.text = tempcontent
      },

      //分片上传
      async fragmentation(val, blob, bytesPerPiece, totalPieces,insert) {
        var start = 0;
        var end;
        var index = 0;
        var filesize = blob.size;
        var filename = blob.name;

        totalPieces = Math.ceil(filesize / bytesPerPiece);

        while (start < filesize) {
          end = start + bytesPerPiece;
          if (end > filesize) {
            end = filesize;
          }

          var chunk = blob.slice(start, end); //切割文件
          var sliceIndex = blob.name + index;
          var formData = new FormData();
          formData.append("file", chunk);

          let params = {
            chunk: index,
            hash: val
          };

          if (index < totalPieces) {
            // console.log('分片次数',index)
            await this.uploadPicChunkAsync(params, formData, blob,insert);
          }
          if (index === totalPieces - 1) {
            // console.log('分片合并')
            params = {
              chunkCount: totalPieces,
              filename: blob.name,
              hash: val
            };
            await this.uploadPicChunkMergeAsync(params, blob,insert);
          }
          start = end;
          index++;
        }
      },

      //获取图集中所有图片
      async listAtlasPicturesAsync() {
        let { status, data, message } = await listAtlasPictures({id:this.$route.query.id,page: 0,pageSize: 100});
        if (status) {
          for (let i = 0; i < data.length; i++) {
            if(data[i].fileInfo.picThumbW640){
              data[i].src = picPrefix + data[i].fileInfo.picThumbW640      
              data[i].srcsmall = picPrefix + data[i].fileInfo.picThumbH160      
              data[i].srcbig = picPrefix + data[i].fileInfo.picThumbW1080
            }else{
              data[i].src = picPrefix + data[i].fileInfo.savepath
              data[i].srcsmall = picPrefix + data[i].fileInfo.savepath      
              data[i].srcbig = picPrefix + data[i].fileInfo.savepath
            }
                  
            let images = "<img class='img' src='"+ data[i].src +"'><br/>"
            this.ruleForm.content += images
          }

          this.imgList = data
          this.choosePic = data
          this.phoneEditor.txt.html(this.ruleForm.content) 
          // console.log(this.ruleForm.content)
        }
      },




      //常规文件上传
      async uploadPicAsync(val,insert) {
        let { status, data, message } = await uploadPic(val);
        if(status){
          let src = picPrefix + data.savepath
          insert(src)
        }
      },

      //分片上传接口第一步
      async uploadPicChunkAsync(params, val, blob,insert) {
        let { status, data, message } = await uploadPicChunk(params, val);
        if (!status) {
          let fd = new FormData();
          fd.append("file", blob);
          this.uploadPicAsync(fd,insert);
        } else {
          console.log("分片第一步");
        }
      },
      //分片上传接口第二步
      async uploadPicChunkMergeAsync(params, blob,insert) {
        let { status, data, message } = await uploadPicChunkMerge(params);
        if (!status) {
          let fd = new FormData();
          fd.append("file", blob);
          this.uploadPicAsync(fd,insert);
        }else{
          let src = picPrefix + data.savepath
          insert(src)
        }
      },
      //通过md5查询图片
      async getFileInfoByHashAsync(val, blob, b, t,insert) {
        let { status, data, message } = await getFileInfoByHash(val);
        if (!status) {
          this.fragmentation(val, blob, b, t,insert);
        }else{
          let src = picPrefix + data.savepath
          insert(src)
        }
      },

      //获取图集中所有图片
      async getPics (val) {
        let { status, data, message } = await getPictures({ ids: val});
        if (status) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].fileInfo.picThumbH160) {
              data[i].src = picPrefix + data[i].fileInfo.picThumbH160
            } else {
              data[i].src = picPrefix + data[i].fileInfo.savepath
            }
          }
          this.choosePic = data
        }
      },

      
    },
    created(){

      let loginInfoString = localStorage.getItem("loginInfo");
      let loginInfoeArray = JSON.parse(loginInfoString)

      this.ruleForm.author = loginInfoeArray.name

      // let isDrawer = this.$route.query.isDrawer
      // if(isDrawer === 'false'){
      //   isDrawer = false
      // }else if(isDrawer === 'true'){
      //   isDrawer = true
      // }

      // if(isDrawer){
      //   let picLoveString = sessionStorage.getItem("picLove");
      //   this.choosePic = JSON.parse(picLoveString)
      //   for (let i = 0; i < this.choosePic.length; i++) {
      //     if(this.choosePic[i].picThumbH160){
      //       this.choosePic[i].srcsmall = this.choosePic[i].picThumbW640
      //       this.choosePic[i].srcbig = this.choosePic[i].picThumbW1080
      //     }else{
      //       this.choosePic[i].srcsmall = this.choosePic[i].src
      //       this.choosePic[i].srcbig = this.choosePic[i].src
      //     }
          
      //     let images = "<img class='img' src='"+ this.choosePic[i].src +"'><br/>"
      //     this.ruleForm.content += images
      //   }
      //   this.imgList = this.choosePic
      //   // this.phoneEditor.txt.html(this.ruleForm.content) 
      // }else{
      //   this.listAtlasPicturesAsync()
      // }


      let isDrawer
      let isAct
      if(this.$route.query.isDrawer){
        isDrawer = this.$route.query.isDrawer

        if(isDrawer === 'false'){
          isDrawer = false
        }else if(isDrawer === 'true'){
          isDrawer = true
        }

        if(isDrawer){
          let picLoveString = sessionStorage.getItem("picLove");
          this.choosePic = JSON.parse(picLoveString)
          for (let i = 0; i < this.choosePic.length; i++) {
            if(this.choosePic[i].picThumbH160){
              this.choosePic[i].srcsmall = this.choosePic[i].picThumbW640
              this.choosePic[i].srcbig = this.choosePic[i].picThumbW1080
            }else{
              this.choosePic[i].srcsmall = this.choosePic[i].src
              this.choosePic[i].srcbig = this.choosePic[i].src
            }
            
            let images = "<img class='img' src='"+ this.choosePic[i].src +"'><br/>"
            this.ruleForm.content += images
          }
          this.imgList = this.choosePic
          }
      }
      if(this.$route.query.isAct){
        isAct = this.$route.query.isAct
        this.isAct = isAct

        if(isAct === 'false'){
          isAct = false
        }else if(isAct === 'true'){
          isAct = true
        }

        if(isAct){
          let picLoveString = sessionStorage.getItem("actPic");
          this.choosePic = JSON.parse(picLoveString)
          for (let i = 0; i < this.choosePic.length; i++) {
            if(this.choosePic[i].picThumbH160){
              this.choosePic[i].srcsmall = this.choosePic[i].picThumbW640
              this.choosePic[i].srcbig = this.choosePic[i].picThumbW1080
            }else{
              this.choosePic[i].srcsmall = this.choosePic[i].src
              this.choosePic[i].srcbig = this.choosePic[i].src
            }
            
            let images = "<img class='img' src='"+ this.choosePic[i].src +"'><br/>"
            this.ruleForm.content += images
          }
          this.imgList = this.choosePic
          }
      }

      if(!this.$route.query.isDrawer && !this.$route.query.isAct && this.$route.query.id){
        this.listAtlasPicturesAsync()
      }

      if(this.$route.query.ids){
        this.getPics(this.$route.query.ids)
      }
      
    },
  mounted() {
    var that = this;
    var spark = new SparkMD5();
    this.phoneEditor = new E("#websiteEditorElem");
    // 上传图片到服务器，base64形式
    // this.phoneEditor.customConfig.uploadImgShowBase64 = true;
    // 隐藏网络图片
    this.phoneEditor.customConfig.showLinkImg = false;

    // 自定义菜单配置
    this.phoneEditor.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // 'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      // 'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 配置服务器端地址
    // this.phoneEditor.customConfig.uploadImgServer = 'http://cdp-local.test.routeryuncs.com/file/uploadPic'

    // 将图片大小限制为 50M
    this.phoneEditor.customConfig.uploadImgMaxSize = 50 * 1024 * 1024

    // 限制一次最多上传 10 张图片
    this.phoneEditor.customConfig.uploadImgMaxLength = 10

    //上传图片事件
    this.phoneEditor.customConfig.customUploadImg = function(files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      files.forEach(item => {
        // var reader = new FileReader();
        // reader.readAsDataURL(item);
        // reader.onload = function(e) {
        //   insert(this.result);
        // };

        // that.$nextTick(() => {
        //   let fd = new FormData();
        //   fd.append("file", item);
        //   that.uploadPicAsync(fd);
        // });

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item,md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        })

        // that.getFileInfoByHashAsync(md5,item,bytesPerPiece,totalPieces)
        // that.getFileInfoByHashAsync(md5,item,bytesPerPiece,totalPieces)
      });

      // files.forEach(item => {
      //   that.$nextTick(()=>{
      //     let fd = new FormData();
      //     fd.append("file", item); // 上传的文件： 键名，键值
      //     axios.post("https://jsonplaceholder.typicode.com/posts/",{file:fd}
      //    )
      //     .then(res => {
      //       console.log(res)
      //     })
      //     .catch(res => {
      //       console.log(res);
      //     });
      //   })

      // 以下是上传图片的接口，视情况而更改就可以啦
      // 上传地址的接口名(fd).then(data => {
      //   // 上传代码返回结果之后，将图片插入到编辑器中
      //   insert(data.url);
      // });
      // });
    };

  

    // 创建一个富文本编辑器
    this.phoneEditor.create();
    // 富文本内容
    this.phoneEditor.txt.html(this.ruleForm.content);
  }
  }
</script>

<style lang="scss" scoped>
.picbj{
  padding-top: 20px;
  padding-left: 90px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .picanddesc{
    display: flex;
    align-items: center;
    width: 550px;
    margin-bottom: 20px;
    .pic{
      width: 240px;
      height: 120px;
      background-size: cover;
    }
  }
}
.bottombtn{
    min-width:calc(100vw - 62px);
    // width: 100%;
    height: 80px;
    background: #fff;
    box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
    border-top: 1px solid #e1e1e1;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    right: 2px;
    z-index: 100002;
    // top: 0;
    // z-index: 99;
    .btn{
        margin-left: auto;
        margin-right: 45px;
        
    }
}

.bottombtn ::v-deep .el-button{
    width: 100px;
    height: 40px;
    font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary{
    background-color: #185ED3;
}
::v-deep .el-form-item__label{
  font-weight: 600;
}

// #websiteEditorElem ::v-deep .w-e-text-container,
// #websiteEditorElem ::v-deep .w-e-toolbar,
// #websiteEditorElem ::v-deep .w-e-menu {
//   z-index: 0 !important;
// }
</style>
